import * as React from 'react'
export const SvgMessagesAppOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M12.006 4C16.976 4 21 7.472 21 11.764c0 4.293-4.023 7.778-8.993 7.778a10.21 10.21 0 01-3.6-.659C7.56 19.566 6.516 20 5.357 20a4.95 4.95 0 01-1.912-.39c1.201-.013 2.147-1.022 2.147-2.26l-.002-.05-.01-.113C3.991 15.787 3 13.88 3 11.765c0-2.053.93-3.915 2.435-5.304l.21-.187.026-.013a8.79 8.79 0 01.615-.498 8.99 8.99 0 01.707-.444C8.427 4.484 10.147 4 12.006 4zM12 6c-3.866 0-7 2.583-7 5.77 0 3.187 3.134 5.77 7 5.77s7-2.583 7-5.77C19 8.583 15.866 6 12 6z" />
  </svg>
)
export default SvgMessagesAppOutline
